import { OdqDateTime } from "~app/shared/model/odq-datetime.model";


export class LegalEntityPracticeV3InvoiceStateModel {
  invoices: Map<string, Invoice[]>;
  loading: Map<string, boolean>;
  memberId: string;
  loadingMember: boolean;

  static get empty(): LegalEntityPracticeV3InvoiceStateModel {
    return {
      invoices: new Map(),
      loading: new Map(),
      memberId: null,
      loadingMember: false
    };
  }
}

export class Invoice {
  number = '';
  date: Date = null;
  description = '';
  feeTypes = '';
  amount = 0.0;
  batchDate: OdqDateTime = null;
  batchCode = '';
  batchStatus = '';
  paymentDate: OdqDateTime = null;
  isCancelled = false;
  comment = '';
  invoiceLines: InvoiceLine[];
  payedAmount: number;
  id: string;
}

class InvoiceLine {
  amount: number;
  tps: number;
  tvq: number;
  totalAmount: number;
  feeDescription: string;
  feeType: FeeType;
}

class FeeType {
  code = '';
  description = '';
  unitaryAmount: 0;
}
